import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import CommonCheckBoxFilters from '@components/commonFilters/CommonCheckBoxFilters';
import CommonSelectFilter from '@components/commonFilters/CommonSelectFilter';
import CommonTextInputFilters from '@components/commonFilters/CommonTextInputFilters';
import { toastError } from '@components/Toast';

import { fetchBrandList } from '@store/actions/BrandAction';
import { fetchSeasonList } from '@store/actions/SeasonAction';
import {
	fetchEmbellishmentSubCategory,
	fetchEnumFilter,
	getCategories as fetchCategories,
	getColors,
	getFabricComposition as fetchFabricComposition,
	getFabricTypes as fetchFabricTypes,
	getMarkets as fetchMarkets
} from '@store/design/action';
import {
	getAllCities,
	getAllColors,
	getAllCountries,
	getAllFabricTypes,
	getAllMarkets,
	getEmbellishmentSubCategory,
	getEnumFilter
} from '@store/reducers';
import { fetchAllCountry, fetchAllTags, fetchSupplierCityByCountry } from '@store/supplier/action';

import { fetchCategoryAndSubCategories, fetchEnumValues } from '@services/commonService';

import ApiClient from '@lib/apiClient';

import {
	FABRIC_TYPE,
	fetchCategoriesForTrimsOrAccessories,
	fetchTagsForTrimsOrAccessories,
	getFixedFabric,
	MATERIAL_TAG_TYPE
} from '@utils/MaterialsUtil';

import { MATERIALS_TYPE, TAGS_TYPE } from '@/constants/constant';

const CommonFilters = ({ type, filterType, isChange = false }) => {
	const [, setIsLoading] = useState(false);
	const [suppliers, setSuppliers] = useState([]);
	const [refNumbers, setRefNumbers] = useState([]);
	const [fabricTypes, setFabricTypes] = useState([]);
	const [fixedTagIdList, setFixedTagIdList] = useState([]);
	const [colorList, setColorList] = useState([]);
	const [compositionList, setCompositionList] = useState([]);
	const [supplierType, setSupplierType] = useState([]);
	const [tempSupplierType, setTempSupplierType] = useState([]);
	const [categoriesAndSubCategorisData, setCategoriesAndSubCategorisData] = useState([]);
	const [, setCategories] = useState([]);
	const [subCategories, setSubCategories] = useState([]);
	const [countryList, setCountryList] = useState([]);
	const [materialQualityList, setMaterialQualityList] = useState([]);
	const [sustainabilityList, setSustainabilityList] = useState([]);
	const dispatch = useDispatch();

	let colors = useSelector(getAllColors);

	useEffect(() => {
		let temp = tempSupplierType.filter((item) => !['Embellishment', 'Washing'].includes(item.text));
		setSupplierType(temp);
	}, [tempSupplierType]);

	useEffect(() => {
		let tempColors = colors.map((item) => {
			return {
				id: item.name,
				name: item.name + ', ' + item.code
			};
		});
		setColorList((prevState) => [...prevState, ...tempColors]);
	}, [colors]);

	let allFabricTypes = useSelector(getAllFabricTypes);
	allFabricTypes = allFabricTypes?.map((item) => {
		return {
			id: item.code,
			name: item.value
		};
	});

	let allEmbellishmentCategories = useSelector(getEnumFilter);
	allEmbellishmentCategories = allEmbellishmentCategories?.embellishmentCategory?.map((item) => {
		return {
			id: item.constant,
			name: item.name
		};
	});

	let allEmbellishmentSubCategories = useSelector(getEmbellishmentSubCategory);
	allEmbellishmentSubCategories = allEmbellishmentSubCategories?.map((item) => {
		return {
			id: item,
			name: item
		};
	});

	let allWashingProcesses = useSelector(getEnumFilter);
	allWashingProcesses = allWashingProcesses?.washingCategory?.map((item) => {
		return {
			id: item.constant,
			name: item.name
		};
	});

	const allMarkets = useSelector(getAllMarkets);

	let certificateTypes = useSelector(getEnumFilter);
	certificateTypes = certificateTypes.certificateType?.map((item) => {
		return {
			id: item.constant,
			name: item.name
		};
	});
	let countries = useSelector(getAllCountries);
	let cities = useSelector(getAllCities);
	const brandList = useSelector((store) => store.brandStore);
	let seasonList = useSelector((store) => store.seasonStore);
	seasonList = seasonList?.map((item) => {
		return {
			id: item.constant,
			name: item.name
		};
	});

	const pricePoints = [
		{
			id: 'LOW',
			name: 'Low'
		},
		{
			id: 'MID',
			name: 'Mid'
		},
		{
			id: 'HIGH',
			name: 'High'
		}
	];

	const pricePointsForMaterials = [
		{
			id: 'LOW',
			name: 'Regular'
		},
		{
			id: 'MID',
			name: 'Mid'
		},
		{
			id: 'HIGH',
			name: 'Premium'
		}
	];
	const baseForMaterials = [
		{
			id: 'PREMIUM',
			name: 'Premium'
		},
		{
			id: 'SEASONAL',
			name: 'Seasonal'
		},
		{
			id: 'CORE',
			name: 'Core'
		},
		{
			id: 'REGULAR',
			name: 'Regular'
		}
	];

	const fetchTagsBySearch = (term = '', type) => {
		dispatch(fetchAllTags(term, type)).finally(() => {
			setIsLoading(false);
		});
	};

	const fetchSelectedCityByCountry = (value) => {
		dispatch(fetchSupplierCityByCountry(value));
	};

	const fetchGarmentsFilters = () => {
		fetchCategoryAndSubCategories().then((data) => {
			let tmpCategories = [];
			for (let cat of data) {
				for (let item of cat.subCategoryResponseList) {
					tmpCategories.push({ id: item.id, name: item.name, isPrimary: item.isPrimary });
				}
			}
			setCategoriesAndSubCategorisData(tmpCategories);
		});
		fetchTagsBySearch('', TAGS_TYPE.MATERIAL_SUSTAINABLE_TAG);
		dispatch(fetchSeasonList());
		dispatch(fetchCategories()).finally(() => {
			setIsLoading(false);
		});
		dispatch(fetchFabricTypes()).finally(() => {
			setIsLoading(false);
		});
		dispatch(fetchMarkets()).finally(() => {
			setIsLoading(false);
		});
	};

	// const onGetgFabricSubCategory = async () => {
	// 	const ids = currentFilters['fabricTypes']?.map((item) => item.id);
	// 	await Http.GET('getFabricSubCategory', `?fabricType=${ids}`)
	// 		.then(({ data }) => {
	// 			if (data) {
	// 				setFabricSubCategories(data);
	// 			}
	// 		})
	// 		.catch(({ response }) => {
	// 			if (response && response.data && response.data.message) {
	// 				toastError(response.data.message);
	// 			} else {
	// 				toastError('Request was unsuccessful.');
	// 			}
	// 		});
	// };

	const onGetgFabricCompositions = async (searchTerm = '') => {
		await ApiClient.GET('getFabricCompositions', `?pageSize=20&search=${searchTerm.replace('%', '')}`)
			.then(({ data }) => {
				if (data) {
					let results = data.data.map((item) => {
						return {
							value: item.id,
							label: `${item.percentage}% ${item.fiberName}`,
							id: item.id,
							name: `${item.percentage}% ${item.fiberName}`
						};
					});
					setCompositionList(results);
				}
			})
			.catch(({ response }) => {
				if (response && response.data && response.data.message) {
					toastError(response.data.message);
				} else {
					toastError('Request was unsuccessful.');
				}
			});
	};

	const onFetchCountryList = async () => {
		await ApiClient.GET('getSupplierCountryList')
			.then(({ data }) => {
				setCountryList(data);
			})
			.catch(() => {
				toastError('Unable to fetch Country list!');
			});
	};

	const fetchFabricType = async () => {
		await ApiClient.GET('getFabricSubCategory')
			.then((response) => {
				const list = response?.data;
				if (list) {
					let fixedData = [
						getFixedFabric(FABRIC_TYPE.KNIT),
						getFixedFabric(FABRIC_TYPE.WOVEN),
						getFixedFabric(FABRIC_TYPE.NON_WOVEN),
						getFixedFabric(FABRIC_TYPE.DENIM),
						getFixedFabric(FABRIC_TYPE.SWEATER),
						getFixedFabric(FABRIC_TYPE.FUNCTIONAL)
					];
					let tmpData = list.map((item) => ({
						id: item.name,
						name: `${item.fabricType}-${item.name}`,
						fabricType: item.fabricType
					}));
					setFabricTypes([...fixedData, ...tmpData]);
				}
			})
			.catch(({ response }) => {
				if (response && response.data && response.data.message) {
					toastError(response.data.message);
				} else {
					toastError('Request was unsuccessful.');
				}
			});
	};

	const fetchFabricFilters = () => {
		fetchTagsBySearch('', TAGS_TYPE.MATERIAL_SUSTAINABLE_TAG);
		dispatch(fetchFabricTypes()).finally(() => {
			setIsLoading(false);
		});
		dispatch(fetchFabricComposition()).finally(() => {
			setIsLoading(false);
		});
		onFetchCountryList();
		onGetgFabricCompositions();
	};

	const fetchSupplierList = async (value) => {
		let item = [];
		if (value) item = suppliers.filter((obj) => obj.name.toLowerCase().includes(value.toLowerCase()));
		if (item.length < 1) {
			setIsLoading(true);
			let params = `?size=200&materialType=MAIN_FABRIC`;
			if (value) {
				params += `&name=${value}`;
			}
			await ApiClient.GET('searchSupplier', params)
				.then((response) => {
					let tmpData = response.data.data?.map((item) => ({
						id: item.id,
						name: item.name
					}));
					setSuppliers(tmpData);
				})
				.catch(() => {
					setIsLoading(false);
				});
		}
	};

	const fetchPantoneColorList = async (value = '') => {
		if (value.trim() === '') {
			let extraColor = ['MULTI', 'AOP', 'Y/D', 'RFD'].map((stringValue) => {
				return {
					id: stringValue,
					name: stringValue
				};
			});
			setColorList(extraColor);
		} else {
			setColorList([]);
		}

		setIsLoading(true);
		dispatch(getColors(value, 200)).finally(() => {
			setIsLoading(false);
		});
	};

	const fetchMaterialReferenceNumberList = async (value, type) => {
		let item = [];
		if (value) item = refNumbers.filter((obj) => obj.name.toLowerCase().includes(value.toLowerCase()));
		if (item.length < 1) {
			setIsLoading(true);
			let params = `?size=200&materialType=` + type;
			if (value) {
				params += `&search=${value}`;
			}
			await ApiClient.GET('searchMaterialReferenceNumber', params)
				.then((response) => {
					let tmpData = response.data.data;
					setRefNumbers(tmpData);
					setIsLoading(false);
				})
				.catch(() => {
					setIsLoading(false);
				});
		}
	};

	const fetchTags = () => {
		ApiClient.GET('fetchFixedTags')
			.then(({ data }) => {
				let characteristicTags = data
					.filter(
						(item) =>
							item.type === 'SUPPLIER_CHARACTERISTIC_DRAPPY' ||
							item.type === 'SUPPLIER_CHARACTERISTIC_HAND_FEEl' ||
							item.type === 'SUPPLIER_CHARACTERISTIC_FINISH_EFFECT' ||
							item.type === 'SUPPLIER_CHARACTERISTIC_LOOK'
					)
					.map((item) => ({
						id: item.id,
						name: item.text
					}));

				let finishAndWashTags = data
					.filter((item) => item.type === 'SUPPLIER_FINISH' || item.type === 'SUPPLIER_WASH')
					.map((item) => ({
						id: item.id,
						name: item.text
					}));
				setFixedTagIdList({
					characteristic: characteristicTags,
					finishAndWash: finishAndWashTags
				});
			})
			.catch((err) => {
				setIsLoading(false);
				toastError(err.response.data.message);
			});
	};

	const fetchEmbellishmentFiters = () => {
		fetchTagsBySearch('', TAGS_TYPE.MATERIAL_SUSTAINABLE_TAG);
		dispatch(fetchEnumFilter('info.nitex.app.materials.EmbellishmentCategory')).finally(() => {
			setIsLoading(false);
		});
		dispatch(fetchEmbellishmentSubCategory()).finally(() => {
			setIsLoading(false);
		});
	};

	const fetchWashingFilters = () => {
		fetchTagsBySearch('', TAGS_TYPE.MATERIAL_SUSTAINABLE_TAG);
		dispatch(fetchEnumFilter('info.nitex.app.materials.WashProcess')).finally(() => {
			setIsLoading(false);
		});
	};

	const fetchMaterialFilters = (type) => {
		switch (type) {
			case MATERIALS_TYPE.GARMENTS:
				fetchGarmentsFilters();
				break;
			case MATERIALS_TYPE.FABRIC:
				fetchMaterialReferenceNumberList('', MATERIALS_TYPE.MAIN_FABRIC).finally();
				fetchFabricType().finally();
				fetchTags();
				fetchFabricFilters();
				break;
			case MATERIALS_TYPE.EMBELLISHMENT:
				fetchEmbellishmentFiters();
				break;
			case MATERIALS_TYPE.TRIMS_ACCESSORIES:
				break;
			case MATERIALS_TYPE.TRIMS:
				fetchMaterialReferenceNumberList('', type).finally();
				fetchCategoriesForTrimsOrAccessories('trimsSubCategories', false, setSubCategories);
				break;
			case MATERIALS_TYPE.BRANDING:
				fetchMaterialReferenceNumberList('', type).finally();
				fetchCategoriesForTrimsOrAccessories('brandingSubCategories', false, setSubCategories);
				break;
			case MATERIALS_TYPE.ACCESSORIES:
				fetchMaterialReferenceNumberList('', MATERIALS_TYPE.BRANDING).finally();
				fetchCategoriesForTrimsOrAccessories('brandingSubCategories', false, setSubCategories);
				break;
			case MATERIALS_TYPE.WASHING:
				fetchWashingFilters();
				break;
			default:
				break;
		}
	};

	useEffect(() => {
		setTimeout(() => {
			if (filterType === 'MATERIAL') {
				fetchSupplierList().finally();
				fetchPantoneColorList().finally();
				dispatch(fetchBrandList());
				if ([MATERIALS_TYPE.TRIMS, MATERIALS_TYPE.ACCESSORIES].includes(type)) {
					fetchTagsForTrimsOrAccessories(
						'',
						MATERIAL_TAG_TYPE.MATERIAL_QUALITY,
						setMaterialQualityList
					);
					fetchTagsForTrimsOrAccessories(
						'',
						MATERIAL_TAG_TYPE.SUSTAINABILITY,
						setSustainabilityList
					);
				}
				fetchMaterialFilters(type);
			}
			if (filterType === 'SUPPLIER') {
				dispatch(fetchBrandList());
				fetchEnumValues('info.nitex.app.supplier.SupplierType', setTempSupplierType);
				fetchEnumValues('info.nitex.app.supplier.SupplierCategory', setCategories);
				fetchTagsBySearch('', TAGS_TYPE.SUPPLIER_STRENGTH);
				fetchTagsBySearch('', TAGS_TYPE.SUPPLIER_ADDITIONAL_TAG);
				fetchTagsBySearch('', TAGS_TYPE.SUPPLIER_CLIENTS);
				dispatch(fetchEnumFilter('info.nitex.app.supplier.CertificateType')).finally(() => {
					setIsLoading(false);
				});
				dispatch(fetchAllCountry());
			}
		}, 400);
	}, [type, isChange]);

	const renderGarmentsFilters = () => {
		return (
			<>
				<CommonTextInputFilters
					type={'designNumber'}
					title={'designNumber'}
					nameWithSpace={'Design Number'}
				/>
				<CommonCheckBoxFilters type={'marketIdList'} data={allMarkets} title={'Market'} />
				<CommonCheckBoxFilters
					type={'categoryIdList'}
					data={categoriesAndSubCategorisData}
					title={'Category'}
				/>
				<CommonCheckBoxFilters type={'brandIds'} data={brandList} title={'Brands'} />
				<CommonCheckBoxFilters type={'seasonList'} data={seasonList} title={'Seasons'} />
				<CommonCheckBoxFilters
					type={'fabricTypes'}
					data={allFabricTypes}
					title={'FabricCategory'}
					nameWithSpace={'Fabric Category'}
				/>
			</>
		);
	};

	const renderFabricFilters = () => {
		return (
			<>
				{/*<CommonCheckBoxFilters type={'fabricTypes'} data={allFabricTypes} title={'Category'} />*/}
				{/*<CommonCheckBoxFilters*/}
				{/*	title={'Subcategory'}*/}
				{/*	type={'constructions'}*/}
				{/*	data={allFabricSubCategories}*/}
				{/*/>*/}
				<CommonCheckBoxFilters
					type={'suppliers'}
					data={suppliers}
					title={'Supplier'}
					onSearchItem={(value) => fetchSupplierList(value)}
				/>
				<CommonCheckBoxFilters
					type={'materialIdList'}
					data={refNumbers}
					title={'refNumberList'}
					nameWithSpace={'Nitex reference'}
					onSearchItem={(value) =>
						fetchMaterialReferenceNumberList(value, MATERIALS_TYPE.MAIN_FABRIC)
					}
				/>
				<CommonCheckBoxFilters
					type={'constructions'}
					data={fabricTypes}
					title={'constructions'}
					nameWithSpace={'Fabric type'}
				/>

				<CommonCheckBoxFilters
					type={'fabricCompositionPartIdList'}
					data={compositionList}
					title={'Composition'}
					onSearchItem={(value) => onGetgFabricCompositions(value)}
				/>
				<CommonTextInputFilters
					title={'Weight'}
					isMulti={true}
					firstType={'minGsm'}
					secondType={'maxGsm'}
				/>
				<CommonCheckBoxFilters
					type={'fixedTagIdList'}
					data={fixedTagIdList?.finishAndWash}
					title={'finishAndWash'}
					nameWithSpace={'Finish & Wash'}
				/>
				<CommonCheckBoxFilters
					type={'fixedTagIdList'}
					data={fixedTagIdList?.characteristic}
					title={'Characteristic'}
				/>
				<CommonCheckBoxFilters
					type={'colorList'}
					data={colorList}
					title={'Color'}
					onSearchItem={(value) => fetchPantoneColorList(value)}
				/>
				<CommonCheckBoxFilters
					type={'countryIds'}
					data={countryList}
					title={'Country'}
					showFilter={false}
				/>
				<CommonCheckBoxFilters
					type={'baseList'}
					title={'baseList'}
					data={baseForMaterials}
					nameWithSpace={'Base '}
					showFilter={false}
				/>
				<CommonCheckBoxFilters
					type={'pricePointList'}
					title={'pricePointList'}
					data={pricePointsForMaterials}
					nameWithSpace={'Price range'}
					showFilter={false}
				/>
				<CommonCheckBoxFilters type={'brandIds'} data={brandList} title={'Brand'} />
			</>
		);
	};

	const renderEmbellishmentFiters = () => {
		return (
			<>
				<CommonCheckBoxFilters
					type={'embellishmentCategories'}
					data={allEmbellishmentCategories}
					title={'Category'}
				/>
				<CommonCheckBoxFilters
					type={'embellishmentSubCategories'}
					data={allEmbellishmentSubCategories}
					title={'Subcategory'}
					nameWithSpace={'Sub category'}
				/>
				{/*<CommonCheckBoxFilters*/}
				{/*	type={'tagIdList'}*/}
				{/*	data={allTags}*/}
				{/*	title={'Sustainable'}*/}
				{/*	onSearchItem={(value) => fetchTagsBySearch(value, TAGS_TYPE.MATERIAL_SUSTAINABLE_TAG)}*/}
				{/*/>*/}
			</>
		);
	};

	const renderTrimsOrBrandingFilters = () => {
		return (
			<>
				<CommonCheckBoxFilters type={'subCategoryIds'} data={subCategories} title={'Category'} />
				<CommonCheckBoxFilters
					type={'materialQualityIds'}
					data={materialQualityList}
					title={'MaterialQuality'}
					nameWithSpace={'Material Quality'}
				/>
				<CommonCheckBoxFilters
					type={'colorList'}
					data={colorList}
					title={'Color'}
					onSearchItem={(value) => fetchPantoneColorList(value)}
				/>
				<CommonCheckBoxFilters
					type={'sustainabilityIds'}
					data={sustainabilityList}
					title={'Sustainability'}
				/>
				<CommonCheckBoxFilters
					type={'specificBrandIds'}
					data={brandList}
					title={'brandSpecific'}
					nameWithSpace={'Brand specific'}
				/>
				<CommonCheckBoxFilters
					type={'suppliers'}
					data={suppliers}
					title={'Supplier'}
					onSearchItem={(value) => fetchSupplierList(value)}
				/>
				<CommonCheckBoxFilters
					type={'materialIdList'}
					data={refNumbers}
					title={'refNumberList'}
					nameWithSpace={'Nitex reference'}
					onSearchItem={(value) => fetchMaterialReferenceNumberList(value, MATERIALS_TYPE.TRIMS)}
				/>
			</>
		);
	};

	const renderWahingFilters = () => {
		return (
			<>
				<CommonCheckBoxFilters
					type={'washProcesses'}
					data={allWashingProcesses}
					title={'Wash'}
					nameWithSpace={'Wash process'}
				/>
				{/*<CommonCheckBoxFilters*/}
				{/*	type={'tagIdList'}*/}
				{/*	data={allTags}*/}
				{/*	title={'Sustainable'}*/}
				{/*	onSearchItem={(value) => fetchTagsBySearch(value, TAGS_TYPE.MATERIAL_SUSTAINABLE_TAG)}*/}
				{/*/>*/}
			</>
		);
	};

	const renderFilters = (type) => {
		switch (type) {
			case MATERIALS_TYPE.GARMENTS:
				return renderGarmentsFilters();
			case MATERIALS_TYPE.FABRIC:
				return renderFabricFilters();
			case MATERIALS_TYPE.EMBELLISHMENT:
				return renderEmbellishmentFiters();
			case MATERIALS_TYPE.TRIMS_ACCESSORIES:
				return renderTrimsOrBrandingFilters();
			case MATERIALS_TYPE.TRIMS:
				return renderTrimsOrBrandingFilters();
			case MATERIALS_TYPE.BRANDING:
				return renderTrimsOrBrandingFilters();
			case MATERIALS_TYPE.ACCESSORIES:
				return renderTrimsOrBrandingFilters();
			case MATERIALS_TYPE.WASHING:
				return renderWahingFilters();
			default:
				return null;
		}
	};

	const renderSupplierFilters = () => {
		return (
			<>
				<CommonCheckBoxFilters
					type={'supplierType'}
					data={supplierType}
					title={'SupplierTypes'}
					nameWithSpace={'Supplier Type'}
				/>
				<CommonCheckBoxFilters type={'supplierCategory'} data={subCategories} title={'Category'} />
				<CommonCheckBoxFilters
					type={'certificateTypeList'}
					data={certificateTypes}
					title={'Certificate'}
				/>
				<CommonSelectFilter
					title={'Location'}
					isMulti={true}
					firstType={'countryId'}
					secondType={'cityId'}
					firstTypeData={countries}
					secondTypeData={cities}
					callBack={fetchSelectedCityByCountry}
				/>
				<CommonCheckBoxFilters type={'brandIds'} data={brandList} title={'Brands'} />
				<CommonCheckBoxFilters
					type={'nominatedBrandIds'}
					title={'nominatedBrandIds'}
					data={brandList}
					nameWithSpace={'Nominated by - Brand list'}
				/>
				<CommonCheckBoxFilters
					type={'pricePointList'}
					title={'pricePointList'}
					data={pricePoints}
					nameWithSpace={'Price point'}
				/>
			</>
		);
	};

	return (
		<div className="filter-bar-section custom-scrollbar open">
			{/* <div className="filter-bar-top">
				<div className="filter-heading d-flex justify-content-between">
					<p>Filter</p>
					<span className="cursor-pointer" onClick={onCollspseFilter}>
						<svg
							xmlns="http://www.w3.org/2000/svg"
							width={24}
							height={24}
							viewBox="0 0 24 24"
							fill="none"
						>
							<path
								d="M19 6.41L17.59 5L12 10.59L6.41 5L5 6.41L10.59 12L5 17.59L6.41 19L12 13.41L17.59 19L19 17.59L13.41 12L19 6.41Z"
								fill="#6A7181"
							/>
						</svg>
					</span>
				</div>
			</div> */}
			{filterType === 'SUPPLIER' ? renderSupplierFilters(type) : renderFilters(type)}
		</div>
	);
};

export default CommonFilters;
